import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/api/settings';
import type { SettingValue } from '@/types/setting';

export const SETTINGS_KEY = ['settings'] as const;

export function useSettings() {
  return useQuery({ queryKey: SETTINGS_KEY, queryFn: api.listSettings });
}
export function useUpdateSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }: { key: string; value: SettingValue }) => api.updateSetting(key, value),
    onSuccess: () => qc.invalidateQueries({ queryKey: SETTINGS_KEY }),
  });
}
